import { createSelector, createSlice } from '@reduxjs/toolkit';
import { TagType, TagTypeType } from 'src/graphql';

export type TagsInitialState = {
  tags: TagType[];
  tagTypes: TagTypeType[];
};

const initialState: TagsInitialState = {
  tags: [],
  tagTypes: [],
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setGlobalTags: (state, action) => {
      if (!action.payload || !action.payload.length) {
        return state;
      }

      state.tags = action.payload ?? [];
    },
    setGlobalTagTypes: (state, action) => {
      if (!action.payload || !action.payload.length) {
        return state;
      }

      state.tagTypes = action.payload ?? [];
    },
  },
  selectors: {
    getOrganisationTags: (state: TagsInitialState) => state.tags,
    getOrganisationTagTypes: (state: TagsInitialState) => state.tagTypes,
    getSortedTags: createSelector(
      (state: TagsInitialState) => state.tagTypes,
      (tagTypes) => tagTypes.map((tagType) => tagType.Tags ?? []).flat(),
    ),
  },
});
export const { setGlobalTags, setGlobalTagTypes } = tagsSlice.actions;
export const { getOrganisationTags, getOrganisationTagTypes, getSortedTags } =
  tagsSlice.selectors;
export const tagsReducer = tagsSlice.reducer;
